export default __webpack_public_path__ + "locales/ar-SA/Article.json?hash=9feabe55be9ec1412fd48cb07d0ce639";